// extracted by mini-css-extract-plugin
export default {"frameParent":"WorkHourIndex_frameParent__nBHf2","attendance":"WorkHourIndex_attendance__4PIFh","annual":"WorkHourIndex_annual__Nq2-8"};